import React, { useEffect, useState } from "react"
import {
  Col,
  Modal,
  ModalFooter,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import AccordianData from "../Accordian/AccordianData"
import ViewImage from "./ViewImage"
import Lightbox from "react-image-lightbox"
import { groupDataByValue } from "helpers/util"
import moment from "moment"
import { useSelector } from "react-redux"

const ViewScreen = ({
  isOpen,
  toggle,
  handlecancel,
  screens,
  HoursReportPagesingle,
  handleAccordion,
  sethandleAccordion,
  selectedclientId,
  selectedprojectId,
  selectname,
  activeReportStatus,
}) => {
  const { accordIndex } = useSelector(state => ({
    accordIndex: state?.globalLists?.accordIndex,
  }))
  const [filterScreens, setfilterScreens] = useState([])

  const groupByKeymulti =
    activeReportStatus?.id == 2 ? "userName" : "subCategoryName"

  useEffect(() => {
    const filterClient =
      selectedclientId?.id == undefined
        ? screens
        : screens
            ?.map(el => el)
            .filter(el => el.categoryId === selectedclientId?.id)

    const filterproject =
      selectedprojectId?.id == undefined
        ? filterClient
        : filterClient
            ?.map(el => el)
            .filter(el => el.subCategoryId === selectedprojectId?.id)

    const fileruserID =
      selectname?.id == undefined
        ? filterproject
        : filterproject
            ?.map(el => el)
            .filter(el => el.userId === selectname?.id)

    setfilterScreens(activeReportStatus?.id == 2 ? fileruserID : filterproject)
  }, [
    selectedclientId,
    selectedprojectId,
    screens,
    selectname,
    activeReportStatus,
  ])

  // const updateProject =
  const groupedDataScreensmulti = groupDataByValue(
    filterScreens || [],
    groupByKeymulti
  )

  const ReportGrouped = Object.entries(groupedDataScreensmulti).map(
    ([date, data], indexValue) => ({
      ...data,
      date,
      data,
      indexValue,
    })
  )
  const groupByKey = "subCategoryName"

  const groupedDataScreens = groupDataByValue(filterScreens || [], groupByKey)

  const groupedScreens = Object?.entries(groupedDataScreens).map(
    ([key, value], index) => ({
      key,
      screenLogs: value?.[0]?.screenLogs,
      index: index,
    })
  )

  const [isGallery, setisGallery] = useState(false)
  const [photoIndex, setphotoIndex] = useState(null)
  const [images, setImages] = useState(null)
  const [multipleScreenAccord, setmultipleScreenAccord] = useState(false)

  useEffect(() => {
    const splitUnderscore =
      typeof multipleScreenAccord === "string" &&
      multipleScreenAccord?.split("_")

    const captureMoment = ReportGrouped[
      splitUnderscore[0]
    ]?.data?.[0]?.screenLogs.map(el => ({
      ...el,
      date: moment(el?.capturetime).format("YYYY-MM-DD"), // or any other desired format
    }))

    const captureMoments = groupDataByValue(captureMoment || [], "date")

    const imagesData = !HoursReportPagesingle
      ? captureMoments[accordIndex]?.map(el => el.imagePath) || []
      : filterScreens?.length == 1
      ? filterScreens?.[0]?.screenLogs?.map(el => el.imagePath)
      : groupedScreens[handleAccordion]?.screenLogs?.map(el => el.imagePath) ||
        []

    setImages(imagesData)
  }, [
    handleAccordion,
    multipleScreenAccord,
    screens,
    accordIndex,
    selectedclientId,
    selectedprojectId,
    filterScreens,
    HoursReportPagesingle,
  ])

  const SubCategoryName = ReportGrouped?.[0]?.data?.[0]?.subCategoryName

  return (
    <div>
      {isGallery ? (
        <>
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            enableZoom={true}
            onCloseRequest={() => {
              setisGallery(false)
            }}
            onMovePrevRequest={() => {
              setphotoIndex((photoIndex + images.length - 1) % images.length)
            }}
            onMoveNextRequest={() => {
              setphotoIndex((photoIndex + 1) % images.length)
            }}
          />
        </>
      ) : null}
      <Modal
        isOpen={isOpen}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal modal-xl"
        tabIndex="-1"
        toggle={toggle}
      >
        <div className="modal-content">
          <ModalHeader toggle={handlecancel}>
            <div className="d-flex">
              <div>View Screen</div>
            </div>
          </ModalHeader>
          <ModalBody
            className="selectAllBody"
            style={{ height: "auto", maxHeight: "400px", overflowY: "scroll" }}
          >
            <Row>
              {!HoursReportPagesingle ? (
                <>
                  {screens?.length === undefined ? (
                    <div className="text-center">No Screens Found</div>
                  ) : (
                    <>
                      {/* toplevel verify screen */}
                      {activeReportStatus?.id == 2 && (
                        <div className="text-center mb-2">
                          Project: <strong>{SubCategoryName}</strong>
                        </div>
                      )}
                      <>
                        {ReportGrouped?.map(
                          ({ date, data, indexValue }, index) => (
                            <>
                              <AccordianData
                                key={date} // Use date for the key of AccordianData
                                item={data} // Pass the data array directly
                                keyIndex={`${index}_${date}_${indexValue}`}
                                sethandleAccordion={setmultipleScreenAccord}
                                handleAccordion={multipleScreenAccord}
                                keyId={date}
                                setphotoIndex={setphotoIndex}
                                setisGallery={setisGallery}
                                MultipleDate={true}
                                activeReportStatus={activeReportStatus}
                              />
                            </>
                          )
                        )}
                      </>
                    </>
                  )}
                </>
              ) : (
                <>
                  {screens?.length === undefined ? (
                    <div className="text-center">No Screens Found</div>
                  ) : (
                    <>
                      {groupedScreens?.length !== 1 ? (
                        <div>
                          {groupedScreens.map(({ key, screenLogs }, index) => (
                            <div key={index}>
                              <AccordianData
                                keyIndex={index} // Use date for the key of AccordianData
                                item={screenLogs} // Pass the data array directly
                                sethandleAccordion={sethandleAccordion}
                                handleAccordion={handleAccordion}
                                keyId={key}
                                setphotoIndex={setphotoIndex}
                                setisGallery={setisGallery}
                              />
                            </div>
                          ))}
                        </div>
                      ) : (
                        <>
                          <div className="text-center mb-2">
                            Project:{" "}
                            <strong>
                              {filterScreens?.map(el => el.subCategoryName)}
                            </strong>
                          </div>
                          <div
                            style={{
                              height: "auto",
                              maxHeight: "500px",
                              overflowY: "scroll",
                            }}
                          >
                            {activeReportStatus?.id !== 2 ? (
                              <>
                                {filterScreens?.map((el, index) => (
                                  <>
                                    <ViewImage
                                      key={index}
                                      keyIndex={index}
                                      keyId={el?.subCategoryName}
                                      item={el?.screenLogs}
                                      setphotoIndex={setphotoIndex}
                                      setisGallery={setisGallery}
                                    />
                                  </>
                                ))}
                              </>
                            ) : (
                              <>
                                {ReportGrouped?.map(
                                  ({ date, data, indexValue }, index) => (
                                    <>
                                      <AccordianData
                                        key={date} // Use date for the key of AccordianData
                                        item={data} // Pass the data array directly
                                        keyIndex={`${index}_${date}_${indexValue}`}
                                        sethandleAccordion={
                                          setmultipleScreenAccord
                                        }
                                        handleAccordion={multipleScreenAccord}
                                        keyId={date}
                                        setphotoIndex={setphotoIndex}
                                        setisGallery={setisGallery}
                                        MultipleDate={true}
                                        activeReportStatus={activeReportStatus}
                                      />
                                    </>
                                  )
                                )}
                              </>
                            )}
                          </div>
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </Row>
          </ModalBody>
          <ModalFooter className="mobile_align_approve">
            <Col>
              <div className="text-end p-0">
                <button
                  type="button"
                  color="primary"
                  className="btn btn-secondary align_width-team"
                  onClick={handlecancel}
                >
                  Cancel
                </button>
              </div>
            </Col>
          </ModalFooter>
        </div>
      </Modal>
    </div>
  )
}

export default ViewScreen
